module.exports = __webpack_public_path__ + "img/icon_ig.cd183c2c.png";